import { UAParser } from 'ua-parser-js';
import { ref } from 'vue';
import i18n from '@/plugins/i18n';

export const useIncompatibleBrowserService = () => {
  const { t } = i18n.global;

  const parser = new UAParser(navigator.userAgent);
  const userAgent = parser.getResult();

  const isIncompatibleBrowser = ref(userAgent.browser.name !== 'Chrome' || Number(userAgent.browser.major) < 58);
  const incompatibleDescription = isIncompatibleBrowser.value
    ? `${userAgent.browser.name === 'Chrome' ? t('incompatibleBrowser.unsupportedVersion') : t('incompatibleBrowser.unsupportedBrowser')}`
    : '';

  return { userAgent, isIncompatibleBrowser, incompatibleDescription };
};
